<template>
  <div class="page">
    <div class="div-header-select">

      <div class="div-center">
        <div>同步时间：</div>
        <el-date-picker
          size="medium"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
      </div>      
    </div>

    <main>
      <el-table  :data="listData"  height="calc(100vh - 200px)" style="width: 100%">
      <!-- <el-table  :data="listData_T" style="width: 100%"> -->
        <el-table-column prop="operatorName" label="操作者名称" align="center">
          <template slot-scope="scope">
            {{scope.row.operatorName?scope.row.operatorName:""}}
          </template>
        </el-table-column>
        <el-table-column prop="logType" label="日志类型" align="center">
        </el-table-column>
        <el-table-column prop="houseSourceNum" label="检索数据总数" align="center">
        </el-table-column>
        <el-table-column label="同步成功数据" align="center">
          <template slot-scope="scope">
            <el-tag @click="querySyncLogDetails(scope.row,'成功')" style="cursor:pointer" size="medium">成功：{{scope.row.houseSuccessNum}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="同步失败数据" align="center">
          <template slot-scope="scope">
            <el-tag  @click="querySyncLogDetails(scope.row,'失败')" style="cursor:pointer" size="medium">失败：{{scope.row.houseFailedNum}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="opTime" label="同步时间" align="center">
        </el-table-column>
        <el-table-column prop="comment" label="备注" align="center">
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
    <el-dialog
      :visible.sync="dialogSyncLogVisible"
      :title="this.titleName"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%"
    >
    <!-- height="calc(100vh - 440px)"  -->
      <el-table  :data="synclogDetailsData" >
            
        <el-table-column label="源数据主键" align="center" width="200px">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              content="test"
              width="400px"
              trigger="click"
            >
             <p>房屋名称： {{ scope.row.leaseSource.AreasAndName }}</p>
             <p>房源状态： {{ scope.row.leaseSource.State }}</p>
             <p>职工编号： {{ scope.row.leaseSource.WorkerID }}</p>
             <p>职工姓名： {{ scope.row.leaseSource.RealName }}</p>
             <p>入住时间： {{ scope.row.leaseSource.InTheTime }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag style="cursor: pointer" size="medium">{{
                  scope.row.WID
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          property="areas"
          align="center" width="300px"
          label="所属区域"
        ></el-table-column>
        <el-table-column
          property="name"
          align="center"
          label="房源名称" width="100px"
        ></el-table-column>
        <el-table-column
          property="logType"
          align="center"
          label="同步结果" width="100px"
        ></el-table-column>
        
        <!-- <el-table-column
          property="inData"
          align="center"
          label="入住时间"
        ></el-table-column> -->
        <el-table-column
          property="failedMsg"
          align="center"
          label="结果描述"
        ></el-table-column>
        <!-- 如果失败 显示失败原因  否则不显示 -->
      </el-table>
      

        
      <footer>
        <el-pagination
          @size-change="logHandleSizeChange"
          @current-change="logHandleCurrentChange"
          :current-page="logPageIdx"
          :page-size="logPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="synclogDetailsTotal"
          :page-sizes="[10, 20, 30, 40, 50]"
        >
        </el-pagination>
      </footer>
      
      <!-- <footer>
        <el-pagination
          :current-page="1"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
          :page-sizes="[10, 20, 30, 40, 50]"
        >
        </el-pagination>
      </footer> -->
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../../Utils";
import { Loading } from "element-ui";
import axios from "axios";
import mixins from "../../minix";

export default {
  name: "Contract",

  mixins: [mixins],

  watch: {
    areaIDSelect() {
      this.initQuery();
    },

    daterange() {
      this.initQuery();
    }
  },

  data() {
    return {
      syncLog:{},
      logType:"",
      logPageIdx: 0,
      synclogDetailsTotal:0,
      titleName:"",
      logPageSize: 20,
      dialogSyncLogVisible: false,
      synclogDetailsData:[],
      commentStr:"",
      isInput:false,
      dialogVisible: false,
      uploadUrl: "",
      uploadData: {
        leaseID: ""
      },
      daterange: ""
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");
    this.query(0);
  },

  methods: {
    
    logHandleCurrentChange(val) {
      this.logPageIdx = val;
      this.querySyncLogDetailsData(val - 1);
    },
    logHandleSizeChange(val) {
      this.logPageIdx = 0;
      this.logPageSize = val;
      this.querySyncLogDetailsData(0);
    },
    // 查询同步日志数据详情
    querySyncLogDetails(row,logType){
      this.syncLog=row;
      this.logType=logType;
      this.querySyncLogDetailsData(0)
      this.logPageSize=this.pageSize
    },
    
    querySyncLogDetailsData(logPageIdx){ 
      this.synclogDetailsData =  []
      if (logPageIdx <= 0) {
        logPageIdx = 0;
      }
      if(this.logType=="成功"){
        this.titleName=this.syncLog.logType+"成功数据列表"

      }else if(this.logType=="失败"){
        this.titleName=this.syncLog.logType+"失败数据列表"
      }
      let data = {
        logID: this.syncLog.id,
        logType: this.logType,
        pageSize: this.logPageSize,
        pageIdx: logPageIdx,
      };

      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "houses/synclogs/details",
        data: data
      })
        .then(value => {
          if(value.data.code!=0){
             this.$message.error(value.data.message)
             return
          }
          this.synclogDetailsTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
             item.leaseSource.AreasAndName = item.leaseSource.AreasName+item.leaseSource.Name
              this.synclogDetailsData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
      this.dialogSyncLogVisible=true
    },
    handleCurrentChange(val) {
      this.pageIdx = val;
      this.query(val - 1);
    },
    handleSizeChange(val) {
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(this.pageIdx);
    },

    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        orgID: this.$route.query.orgID,
        pageSize: this.pageSize,
        pageIdx: pageIdx,
      };

      if(Array.isArray(this.daterange)) {
        data.start = parseInt(this.daterange[0].getTime() / 1000);
        data.end = parseInt(this.daterange[1].getTime() / 1000 + 60 * 60 * 24 -1);
      }

      const loading = Loading.service({
        lock: true,
        text: "正在请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "houses/synclogs",
        data: data
      })
        .then(value => {
          this.listData = []
          this.itemTotal = value.data.total;
          
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.opTime = Utils.long2second(item.opTime * 1000);
              item.edit=false
              item.tmpComment=""
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../style.css";
main {
  margin-top: 10px;
}
</style>
